import React from 'react';
import Header from './Header';
import Footer from './Footer';
import './Layout.css';
import ScrollToTop from './ScrollUp';
import WhatsAppButton from './Whatsapp';
//import Balloon from './Balloon';


function Layout({ children }) {


  return (
    <>
      <Header />
      <main className="site-main">{children}</main>
      <Footer />

      <div className="floating-button">
        <WhatsAppButton 
          phoneNumber="9448440647" 
          message="Hello! I would like to inquire about your services." 
        />
        <ScrollToTop />
      </div>
      {/* <Balloon /> */}
      
      </>
  );
}

export default Layout;